import React from 'react'

type IconProps = {
  className?: string
}

export const ChevronDown = ({ className }: IconProps) => {
  return (
    <svg className={className} viewBox="0 0 26 26">
      <path d="M6.414 7.586l-2.828 2.828L13 19.828l9.414-9.414-2.828-2.828L13 14.172 6.414 7.586z" />
    </svg>
  )
}

type MenuIconProps = {
  color: string
}

export const MenuIcon = ({ color }: MenuIconProps) => {
  return (
    <svg
      id="menu"
      xmlns="http://www.w3.org/2000/svg"
      style={{ stroke: color }}
      viewBox="0 0 34 34"
    >
      <line
        x1="9.42"
        y1="10.5"
        x2="25.3"
        y2="10.5"
        fill="none"
        strokeWidth="2"
        style={{ isolation: 'isolate' }}
      ></line>
      <line
        x1="9.42"
        y1="16.57"
        x2="25.3"
        y2="16.57"
        fill="none"
        strokeWidth="2.12"
        style={{ isolation: 'isolate' }}
      ></line>
      <line
        x1="9.42"
        y1="22.46"
        x2="19.36"
        y2="22.46"
        fill="none"
        strokeWidth="2.12"
        style={{ isolation: 'isolate' }}
      ></line>
    </svg>
  )
}

export const ChevronCircleDown = ({ className }: IconProps) => {
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fas"
      data-icon="chevron-circle-down"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      className={className}
    >
      <path
        fill="currentColor"
        d="M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"
        className=""
      ></path>
    </svg>
  )
}

export const PlayIcon = ({ className }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className={className}
      fill="currentColor"
    >
      <path d="M3 22v-20l18 10-18 10z" />
    </svg>
  )
}
